import React from 'react';
import { Logo } from '../../types/navigation.types';
import { X } from 'lucide-react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface SidebarLogoProps {
  logo: Logo;
  isCollapsed: boolean;
  setShowSidebar?: (show: boolean) => void;
}

const SidebarLogo: React.FC<SidebarLogoProps> = ({
  logo,
  isCollapsed,
  setShowSidebar,
}) => {
  const isDark = useSelector((state: RootState) => state.theme.isDarkMode);
  return (
    <div className="flex items-start lg:items-center justify-start lg:justify-center">
      <div className="flex px-4 py-3 items-center h-[44px] rounded-md w-full lg:w-fit gap-4 bg-background-main">
        <span className="flex items-center justify-between w-full">
          <span className="flex items-center gap-4">
            <img className="h-7 w-7 text-text-primary" src={isDark ? logo.icon : logo.iconBlack} />
            {!isCollapsed && (
              <span className="text-sm text-text-primary font-normal whitespace-nowrap">
                {logo.text}
              </span>
            )}
          </span>
          {setShowSidebar && (
            <X className="text-text-primary" onClick={() => setShowSidebar(false)} />
          )}
        </span>
      </div>
    </div>
  );
};

export default SidebarLogo;
